export default "__VITE_ASSET__c55b4e02__"